import React from "react";
import { Link } from "react-router-dom";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service here
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.container}>
          <div style={styles.card}>
            <span style={styles.icon}>⚠️</span>
            <h2 style={styles.heading}>Something went wrong</h2>
            <p style={styles.text}>
              An error occurred while loading this section of the website. We apologize for the inconvenience.
            </p>
            <div style={styles.actions}>
              <button
                onClick={() => {
                  this.setState({ hasError: false, error: null });
                  window.location.reload();
                }}
                style={styles.button}
              >
                Reload Page
              </button>
              <a href="/" style={styles.link}>
                Go to Homepage
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "80vh",
    padding: "20px",
    fontFamily: "system-ui, -apple-system, sans-serif",
    textAlign: "center",
  },
  card: {
    maxWidth: "500px",
    padding: "40px 30px",
    borderRadius: "16px",
    background: "#fff",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
    border: "1px solid #eaeaea",
  },
  icon: {
    fontSize: "48px",
    display: "block",
    marginBottom: "16px",
  },
  heading: {
    fontSize: "24px",
    color: "#222",
    marginBottom: "12px",
    fontWeight: "600",
  },
  text: {
    fontSize: "15px",
    color: "#666",
    lineHeight: "1.6",
    marginBottom: "24px",
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    alignItems: "center",
  },
  button: {
    padding: "12px 24px",
    borderRadius: "8px",
    background: "#0d6efd",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: "500",
    width: "100%",
    transition: "background 0.2s",
  },
  link: {
    color: "#0d6efd",
    textDecoration: "none",
    fontSize: "14px",
    marginTop: "8px",
  },
};
